{
  "language": {
    "label": "Langue",
    "select": "Sélectionner la langue"
  },
  "nav": {
    "howItWorks": "Comment ça marche",
    "programmes": "Programmes",
    "pricing": "Tarifs",
    "contact": "Contactez-nous",
    "admin": "Admin",
    "resources": "Ressources pour parents",
    "reviews": "Avis de parents",
    "signIn": "Connexion parents",
    "portal": "Portail parents",
    "book": "Réserver une évaluation gratuite",
    "terms": "Conditions générales",
    "refund": "Politique de remboursement",
    "privacy": "Avis de confidentialité",
    "tagline": "Anglais en ligne premium pour jeunes apprenants"
  },
  "hero": {
    "title": "Cours d'anglais en ligne pour enfants développant une réelle aisance orale, de 4 à 12 ans",
    "rating": "Enseignante certifiée CELTA · Diplômée en anglais et psychologie",
    "credential": "Enseignante certifiée CELTA",
    "subtitleBefore": "Cours d'anglais en direct pour enfants de 4 à 12 ans, avec un maximum de 5 élèves par classe et plus de 80 % de temps de parole actif. La progression est alignée sur notre",
    "subtitleLink": "programme d'études conforme au CECRL",
    "ctaPrimary": "Réserver une évaluation gratuite",
    "ctaSecondary": "Voir les tarifs d'inscription",
    "liveLesson": "Cours en direct · Cohorte A1",
    "imageAlt": "Trois jeunes enfants riant et parlant pendant un cours d'anglais en ligne en direct pour enfants chez Smart Word Labs"
  },
  "approach": {
    "heading": "Petits groupes. Grande confiance à l'oral.",
    "link": "Découvrez notre méthode étape par étape"
  },
  "programmes": {
    "heading": "Programmes par âge et niveau",
    "intro": "Chaque inscription commence par une évaluation gratuite et un plan d'apprentissage écrit. Les enfants sont placés dans une micro-cohorte correspondant à leur tranche d'âge et à leur niveau CECRL, tandis que la maîtrise IELTS propose un coaching privé individuel pour les candidats de tout âge.",
    "cefrLabel": "Alignement CECRL",
    "cefr": "CECRL {{level}}",
    "lessonLength": "Durée du cours",
    "cohortSize": "Taille de la cohorte",
    "speakingTime": " · plus de 80 % de temps de parole",
    "explore": "Explorer {{title}}",
    "exploreAria": "Voir tous les détails de {{title}} pour les {{band}}",
    "bookAria": "Réserver une évaluation d'anglais gratuite pour {{title}}, {{band}}",
    "book": "Réserver une évaluation gratuite",
    "compareAll": "Comparer tous les programmes en détail",
    "items": {
      "early-phonics-explorers": {
        "band": "4–6 ans",
        "title": "Early Phonics Explorers",
        "summary": "Cours d'anglais en ligne en direct pour enfants de 4 à 6 ans : phonétique synthétique, premiers mots et confiance à l'oral dans une micro-cohorte de cinq.",
        "duration": "Cours de 30 minutes",
        "cohort": "Max 5 enfants",
        "spots": "5 enfants max. par groupe"
      },
      "literacy-builders": {
        "band": "7–9 ans",
        "title": "Literacy Builders",
        "summary": "Soutien scolaire d'anglais en petits groupes pour enfants de 7 à 9 ans couvrant la fluidité de lecture, l'écriture structurée et la conversation quotidienne, aligné sur les niveaux A1–A2 du CECRL.",
        "duration": "Cours de 45 minutes",
        "cohort": "Max 5 enfants",
        "spots": "5 enfants max. par groupe"
      },
      "confident-communicators": {
        "band": "10–12 ans",
        "title": "Confident Communicators",
        "summary": "Un cours d'anglais CECRL pour enfants de 10 à 12 ans développant les compétences de rédaction d'essais, de débat et d'entretien en vue de l'entrée au collège.",
        "duration": "Cours de 45 minutes",
        "cohort": "Max 5 enfants",
        "spots": "5 enfants max. par groupe"
      },
      "ielts-mastery": {
        "band": "Tous les âges",
        "title": "IELTS Mastery 1-on-1",
        "summary": "Coaching privé IELTS pour la formation académique ou générale, avec stratégie de score, simulations d'examens oraux et retours détaillés sur l'écrit.",
        "duration": "Cours de 45 minutes",
        "cohort": "Individuel",
        "spots": "Cours privés 1-à-1"
      }
    }
  },
  "pricing": {
    "heading": "Tarification mensuelle simple",
    "headingPage": "Tarifs des cours d'anglais en ligne pour enfants",
    "intro": "Un forfait mensuel par enfant, facturé mensuellement et résiliable à tout moment. Le cours d'évaluation et le plan d'apprentissage sont toujours gratuits.",
    "introTeaser": "Un forfait mensuel par enfant, facturé mensuellement et résiliable à tout moment. L'évaluation gratuite et le plan d'apprentissage écrit sont inclus dans chaque forfait.",
    "mostPopular": "Le plus populaire",
    "perMonth": "USD / mois",
    "perLesson": "{{amount}} USD par cours",
    "subscribe": "S'abonner",
    "signInToSubscribe": "Connectez-vous pour vous abonner",
    "seeMore": "Découvrez ce que chaque forfait inclut sur la page des tarifs",
    "noteLessonLength": "La durée des cours varie selon le groupe d'âge : 30 minutes pour les 4–6 ans, 45 minutes pour les 7–12 ans.",
    "noteCohorts": "Les cours ont lieu à 9h, 10h, 11h, 14h, 15h, 16h, 17h et 18h, heure de Toronto (ET). Votre créneau exact est confirmé lors de l'évaluation gratuite.",
    "noteSibling": "L'inscription d'un frère ou d'une sœur permet d'économiser 10 % sur chaque enfant supplémentaire. Prix en USD.",
    "tiers": {
      "cohort_starter_monthly": {
        "name": "Cohort Starter",
        "lessons": "8 cours / mois",
        "cadence": "2 cours par semaine",
        "features": [
          "Micro-cohorte de maximum 5 enfants",
          "Cours en direct de 45 minutes, 2x par semaine",
          "Devoirs hebdomadaires avec retour de l'enseignante",
          "Rapport de progression mensuel CECRL",
          "Messagerie directe avec Ms. Salma",
          "2 crédits de report chaque mois"
        ]
      },
      "cohort_intensive_monthly": {
        "name": "Cohort Intensive",
        "lessons": "16 cours / mois",
        "cadence": "4 cours par semaine",
        "features": [
          "Micro-cohorte de maximum 5 enfants",
          "Cours en direct de 45 minutes, 4x par semaine",
          "Devoirs hebdomadaires avec retour de l'enseignante",
          "Rapport de progression mensuel CECRL",
          "Messagerie directe avec Ms. Salma",
          "4 crédits de report chaque mois",
          "Placement prioritaire en cohorte"
        ]
      },
      "private_1on1_monthly": {
        "name": "Private 1-on-1",
        "lessons": "16 cours / mois",
        "cadence": "4 cours par semaine",
        "features": [
          "Cours individuels, pas de cohorte — programme entièrement personnalisé",
          "Cours en direct de 45 minutes, 4x par semaine",
          "Devoirs hebdomadaires avec retour de l'enseignante",
          "Rapport de progression mensuel CECRL",
          "Messagerie directe avec Ms. Salma",
          "Report flexible (pas de limite mensuelle)",
          "Rythme personnalisé adapté aux objectifs de l'enfant"
        ]
      },
      "ielts_mastery_1on1_monthly": {
        "name": "IELTS Mastery 1-on-1",
        "lessons": "16 cours / mois",
        "cadence": "4 cours par semaine",
        "features": [
          "Ouvert à tous les âges — pas de limite d'âge supérieure",
          "Préparation ciblée pour l'IELTS Académique ou Général",
          "Cours individuels, pas de cohorte — stratégie personnalisée de score cible",
          "Sessions intensives en direct de 45 minutes couvrant l'expression orale, la lecture, l'écriture et l'écoute",
          "Évaluations détaillées de l'écrit IELTS Task 1 & Task 2 avec retour sur le score",
          "Simulations d'examens oraux individuels en direct avec retours de type examinateur",
          "Pratique ciblée de la lecture et de l'écoute avec analyse d'erreurs et techniques de gestion du temps",
          "Messagerie directe avec Ms. Salma",
          "Report flexible (pas de limite mensuelle)",
          "Rythme personnalisé adapté à la date de votre examen"
        ]
      },
      "starter_pack_onetime": {
        "name": "Starter Pack",
        "lessons": "4 cours privés en tête-à-tête",
        "cadence": "30 minutes chacun",
        "features": []
      }
    },
    "oneTime": "USD paiement unique",
    "getStarterPack": "Obtenir le Starter Pack",
    "starterNote": "Essayez 4 cours avant de vous engager. Si vous vous inscrivez dans les 30 jours, les 79 $ sont entièrement déduits de votre premier mois."
  }
}
